export default __webpack_public_path__ + "static/media/icon-support.1490885b.svg";